import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TravelportPccService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<any>(
      `${this.baseUrl}/TravelPortPccsForImportPnr/list`
    );
  }

  create(model: any) {
    return this.http.post(
      `${this.baseUrl}/TravelPortPccsForImportPnr/create`,
      model
    );
  }

  update(model: any) {
    return this.http.put(
      `${this.baseUrl}/TravelPortPccsForImportPnr/update`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete(
      `${this.baseUrl}/TravelPortPccsForImportPnr/delete/${id}`
    );
  }

  changeStatus(id: number, isActive: boolean) {
    return this.http.put(
      `${this.baseUrl}/TravelPortPccsForImportPnr/status`,
      {
        id,
        isActive
      }
    );
  }
}
